import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#F90"
        d="M8 16A8 8 0 118 0a8 8 0 010 16zm0-1.6A6.4 6.4 0 108 1.6a6.4 6.4 0 000 12.8zm-.8-4h1.6V12H7.2v-1.6zm0-6.4h1.6v4.8H7.2V4z"
      ></path>
    </svg>
  )
}

export default Icon
